import { AgentNatureMandate } from "../company/types";
import { DeclarativeNif } from "../flow/types";

export type companyAdminListTypeResponse = {
  companyList: companyAdminListType[];
  hasMore: boolean;
};
export type companyAdminListType = {
  uuid: string;
  uuidLegal: string;
  legal_name: string;
  rcs: string;
  olkypass_lvl: number;
  olkypass_status: number;
  alerts: string[];
  bo_count: number;
  agent_count: number;
};
export enum CompanySituation {
  NEW_CLIENT = "NEW_CLIENT",
  OLKYPASS_VERIFICATION = "OLKYPASS_VERIFICATION",
  ALGOREG_VERIFICATION = "ALGOREG_VERIFICATION",
  OPP_VERIFICATION = "OPP_VERIFICATION",
  VALIDATED = "VALIDATED"
}
export type legalEntityUpdateSituation = {
  companyUuid: string;
  situation: string;
};
export type LegalEntityAdminCreateSchema = {
  legal_name: string | null;
  country_incorporation_id: string | null;
  date_incorporation: Date | null;
  legal_form: string | null;
  csp_id: string | null;
  activity_code: string | null;
  address: {
    country_id: string | null;
    address_1: string | null;
    zip_code?: string | null | undefined;
    city?: string | null | undefined;
    tag?: string | null | undefined;
    isPrincipalAddress?: boolean | undefined;
  };
  agent_nature_relation?: AgentNatureMandate;
  RCS_number?: string | null | undefined;
  address_activity?:
    | {
        country_id: string | null;
        address_1: string | null;
        address_2?: string | null | undefined;
        address_3?: string | null | undefined;
        zip_code?: string | null | undefined;
        city?: string | null | undefined;
        tag?: string | null | undefined;
        isPrincipalAddress?: boolean | undefined;
      }
    | undefined
    | null;
  website_url?: string | null | undefined;
  brand?: string | null;
  VATNumber?: string | undefined;
  tax_address?: DeclarativeNif | null;
  country_residence_id?: string | undefined;
  lei_number?: string | undefined | null;
  shareholder_is_legal_entity: boolean;
};
